import { Save } from "@mui/icons-material";
import { Button, Portal, Stack } from "@mui/material";
import { chartService } from "Apis";
import FullWidthHeightGlass from "Components/Page/FullWidthHeightGlass";
import { PageSubAction } from "consts";
import { ChartBuilder } from "features/chartLibrary";
import { TOP_BAR_HEIGHT } from "features/leftMenu/constants";
import { useMount, useNotification, useSelectedProject } from "Hooks";
import { useCharts } from "Hooks/useCharts";
import { parseChartFromResponse } from "features/chartLibrary/utils";
import { IChart } from "Interfaces";
import { useLayoutContext } from "Providers/LayoutProvider";
import { useReportBuilderContext } from "Providers/ReportBuilderProvider";
import { useCallback, useLayoutEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

function ChartBuilderPage() {
  const { setPageTitle } = useLayoutContext();
  const history = useHistory();
  const { selectedProject } = useSelectedProject();
  const { chart, setChart } = useReportBuilderContext();
  const { chartId } = useParams<{ chartId: string }>();
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const { updateChart, saveNewChart } = useCharts();

  useLayoutEffect(() => {
    setPageTitle("Chart Designer");
    return () => {
      setPageTitle("");
    };
  }, []);

  useMount(() => {
    if (!chartId) {
      return;
    }
    const load = async () => {
      const res = await chartService.chartServiceReadChart({
        projectId: selectedProject?.id as number,
        chartId: Number(chartId),
      });

      const o = parseChartFromResponse(res);
      setChart({
        ...o,
        yAxisKeys:
          o.yAxisKeys.length > 0
            ? o.yAxisKeys
            : [
                {
                  key: "l",
                  fields: [""],
                },
              ],
      });
    };
    load();
  });

  const onSave = useCallback(
    async (goBack?: boolean) => {
      try {
        let res: IChart;
        if (!chart.id) {
          res = await saveNewChart(chart, selectedProject);
        } else {
          res = await updateChart(chart, selectedProject);
        }
        setChart(res);
        showSuccessNotification(`${chart.name} Saved`);

        if (goBack) {
          history.push("../chart-library");
        }
      } catch (error) {
        showErrorNotification("Something Went Wrong");
      }
    },
    [
      chart,
      selectedProject,
      showSuccessNotification,
      showErrorNotification,
      history,
      setChart,
      updateChart,
      saveNewChart,
    ],
  );

  return (
    <FullWidthHeightGlass height={`calc(100vh - ${TOP_BAR_HEIGHT}px - 85px)`}>
      <Portal container={() => document.getElementById(PageSubAction)}>
        <Stack direction={"row"} spacing={2} sx={{ width: 400 }}>
          <Button
            color="secondary"
            onClick={() => history.push("../chart-library")}
          >
            Cancel
          </Button>

          <Button startIcon={<Save />} onClick={() => onSave(false)}>
            Save
          </Button>
          <Button startIcon={<Save />} onClick={() => onSave(true)}>
            Save & back to Library
          </Button>
        </Stack>
      </Portal>
      <ChartBuilder />
    </FullWidthHeightGlass>
  );
}

export default ChartBuilderPage;
